import React, { createContext, useState, useEffect, useContext } from "react";

const BookingContext = createContext(null);

export const BookingProvider = ({ uniqueKey, id, trans, locale, children }) => {
  const [bookingData, setBookingData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedTime, setSelectedTime] = useState("");
  const [bookedHash, setBookedHash] = useState(null);

  const getBookingData = () => {
    fetch(`/booking/${uniqueKey}/booking_days`)
      .then((res) => {
        if (!res.ok) {
          throw new Error("Error loading booking days");
        }
        return res.json();
      })
      .then((data) => {
        setBookingData(data);
      })
      .catch((err) => {
        setError(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    resetAll();
  }, [uniqueKey]);

  const resetAll = () => {
    setLoading(true);
    setBookingData(null);
    setName("");
    setEmail("");
    setSelectedDate(new Date());
    setSelectedTime("");
    setBookedHash(null);
    getBookingData();
  };

  return (
    <BookingContext.Provider
      value={{
        id,
        uniqueKey,
        bookingData,
        loading,
        error,
        trans,
        locale,
        name,
        setName,
        email,
        setEmail,
        selectedDate,
        setSelectedDate,
        selectedTime,
        setSelectedTime,
        bookedHash,
        setBookedHash,
        resetAll,
      }}
    >
      {children}
    </BookingContext.Provider>
  );
};

export const useBooking = () => {
  return useContext(BookingContext);
};
